import { gql } from '@efficiently/client-core-graphql-models';

export const TAG_FIELDS = gql(`
	fragment TagFields on Tag {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		orgId
		name
		type
		assigned {
			...TagToContentFields
		}
	}
`);
